import React from 'react';

import {$} from './ext-refs';

/* Simple Bootstrap modal scaffolding
 * Note that boostrap data tags will work.
 * If you need to close the dialog explicitly from a button handler, call
 * this.closeDialog();
 *
 * This component expects handleClose() property
*/
class BootstrapDialog extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // enhancement needed later to pass all the options available to bootstrap modals
        $(this.modal).modal({
            backdrop: 'static',
            show: true,
            keyboard: typeof this.props.keyboard !== 'undefined' ? this.props.keyboard : true
        });
        if (this.props.handleClose) {
            // the accept button callback will be called first, before this
            // event.
            $(this.modal).on("hidden.bs.modal", (e) => {
                // console.log('Bootstrap: hidden.bs.modal called');
                this.props.handleClose(e);
            });
        }
    }

    componentWillUnmount() {
        $(this.modal).modal("hide");
    }

    closeDialog() {
        console.debug('BootstrapDialog closeDialog()');
        $(this.modal).modal("hide");
        if (this.props.handleClose) {
            this.props.handleClose();
        }
    }

    render() {
        return (
            <div className="modal mdb-modal fade"
                 tabIndex="-1"
                 ref={modal => (this.modal = modal)}
                 role="dialog"
                 aria-labelledby={this.props.labelledby}
                 aria-hidden="true">
                {this.props.children}
            </div>
        );
    }
}

export default BootstrapDialog;